import FJNavBar from '../../common/components/FJNavBar/FJNavBar.jsx';
import FJTextToSpeechData from '../../config/dataConfig/FJTextToSpeechData.js';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../hooks/useLocalStore.js';
import { useCallback, useEffect, useState, useLayoutEffect } from 'react';
import FJActionTextToSpeech from '../../redux/action/FJActionTextToSpeech.js';
import FJTextToSpeechLeftContainer from './FJTextToSpeechLeft/container/FJTextToSpeechLeftContainer.jsx';
import FJTextToSpeechRightContainer from './FJTextToSpeechRight/container/FJTextToSpeechRightContainer.jsx';
import styles from './index.module.less';
import FJVoiceCloningContainer from '../FJVoiceCloning/container/FJVoiceCloningContainer.jsx';
import FJCodecStore from '../../store/FJCodecStore.js';
import FJLibraryContainer from './FJTextToSpeechRight/container/FJLibraryContainer.jsx';
import FJFavoriteContainer from './FJTextToSpeechRight/container/FJFavoriteContainer.jsx';
import FJHistoryContainer from './FJTextToSpeechRight/container/FJHistoryContainer.jsx';
import FJConstant from '../../constants/FJConstant.js';
import FJActionCommon from '../../redux/action/FJActionCommon.js';
import { setSliceSelectListAction } from '../../redux/slices/FJSliceCommon.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJUtil from '../../util/FJUtil.js';
import FJHeaderConfig from '../../config/FJHeaderConfig.js';

const MENU_LIST = FJTextToSpeechData.MENU_LIST;

const FJTextToSpeech = () => {
    useLocalStore();
    const tabIndex = useSelector(state => state.textToSpeech.tabIndex);
    const dispatch = useDispatch();
    const [hasTooltip, setHasTooltip] = useState(false);

    useEffect(() => {
        const localPath = window.location.pathname;
        const keys = localPath.split('/');
        const info = {
            'text-to-speech': FJConstant.TEXT_TO_SPEECH,
            'voice-cloning': FJConstant.CLONE_VOICE,
        };
        for (const key in info) {
            const result = keys.find(value => value && value === key);
            if (result) {
                onChangeTabIndex(info[key]);
                break;
            }
        }
        FJCodecStore.init();
    }, []);

    useEffect(() => {
        dispatch(FJActionTextToSpeech.initAction());
        // FJTextToSpeechUtil.dealData();
    }, []);

    const onChangeTabIndex = useCallback(
        value => {
            const index = MENU_LIST.findIndex(item => item.value === value);
            dispatch(FJActionTextToSpeech.changeTabIndexAction(index));
            dispatch(FJActionCommon.setIsMultipleModeAction(false));
            dispatch(setSliceSelectListAction([]));
            if (index === 0 || index === 1) {
                const tag = FJLocalStore.currentTag();
                let linkTag = tag === 'en' ? `` : `/${tag}`;
                const { origin, search } = window.location;
                const tab = ['ai-text-to-speech', 'ai-voice-cloning'];
                const href = FJHeaderConfig.aiMenuList.find(item => item.title === tab[index])?.href;
                FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
                document.title = FJLocalStore._(tab[index]) + ' | FlexClip';
            }
        },
        [dispatch],
    );

    const selectTab = MENU_LIST[tabIndex]?.value;

    useLayoutEffect(() => {
        _checkHasTooltip();

        window.addEventListener('resize', _checkHasTooltip);
        return () => {
            window.removeEventListener('resize', _checkHasTooltip);
        };
    }, []);

    const _checkHasTooltip = () => {
        setHasTooltip(document.body.clientWidth <= 1400);
    };

    return (
        <>
            <FJNavBar
                tabList={MENU_LIST}
                onChangeTab={onChangeTabIndex}
                selectTab={selectTab}
                className={styles.nav}
                hasTooltip={hasTooltip}
                adaptWidth={1441}
                isMusicNav={true}
            />
            {tabIndex === 0 && (
                <>
                    <FJTextToSpeechLeftContainer />
                    <FJTextToSpeechRightContainer />
                </>
            )}
            {tabIndex === 1 && <FJVoiceCloningContainer />}
            {tabIndex === 3 && <FJLibraryContainer />}
            {tabIndex === 4 && <FJFavoriteContainer />}
            {tabIndex === 5 && <FJHistoryContainer />}
        </>
    );
};

export default FJTextToSpeech;
